import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAuditLogExportRequested.meta';

export type UseTrackAuditLogExportRequestedParams = {
  end_date: string;
  start_date: string;
  workspace_id: string;
};

export const useTrackAuditLogExportRequested = () => {
  const { track } = useAnalyticsUtilities();

  const trackAuditLogExportRequested = useCallback(
    (params: UseTrackAuditLogExportRequestedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAuditLogExportRequested };
};
